












































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IActivity } from "@/types";
import { getMineActivityInfo } from "@/api";
import MyFooter from "@/components/Footer.vue";
import Rule from "@/components/Rule.vue";
import ActLeaderboard from "@/components/ActLeaderboard.vue";
import MyTitle from "@/components/Title.vue";

@Component({
  components: {
    MyFooter,
    Rule,
    ActLeaderboard,
    MyTitle
  },
  created() {
    console.log("excute========");
  }
})
export default class Home extends Vue {
  @Prop({ type: Number, required: true }) actId!: number;
  loading = true;
  activity: IActivity = {
    configurationText: {
      banner: {}
    }
  } as IActivity;
  get configurationText() {
    return this.activity.configurationText;
  }
  get banner() {
    return this.configurationText.banner;
  }
  get activityRule() {
    return this.configurationText.activityRule;
  }
  get bannerStyle() {
    return {
      backgroundImage: `url("${this.banner.url}")`
    };
  }
  get invitationBuyCourseUserInfo() {
    return this.activity.invitationBuyCourseUserInfo || {};
  }
  get invitationCardUserInfo() {
    return this.activity.invitationCardUserInfo || {};
  }
  @Watch("actId", { immediate: true })
  async getMineActivityInfo(actId: number) {
    this.loading = true;
    this.activity = await getMineActivityInfo(actId);
    if (this.activity.configurationText.pageTitle) {
      document.title = this.activity.configurationText.pageTitle;
    }
    this.$rulePopup({
      value: false,
      rule: this.activity.configurationText.activityRule.content
    });
    this.loading = false;
  }
  toMy() {
    this.$router.push({ name: "my", params: { actId: String(this.actId) } });
  }
}
